import { IMetadata } from '../../interfaces/common';
import { getApiCached } from '../../utils/api';

export interface IPatientAgeRange extends IMetadata {
  patientAgeRangeId: number;
  patientAgeRangeDescription: string;
}

export const getPatientAgeRanges = () =>
  getApiCached<IPatientAgeRange[]>('lookup/patientageranges');
